import { isNilOrEmptyString } from 'ramda-extension';

import producedProduction from 'features/views/production/common';
import { cleanse, toIsoDateFormat } from 'utils';

const { productionStatuses } = producedProduction.constants;

export const documentsQueryParamsFactory = () => {
	return {
		page: 0,
		size: 1000,
	};
};

export const documentsBodyFactory = (formData, userRole) => {
	const requestBody = {
		productionDocStatusIds: [productionStatuses.VALID],
		orgStruct: {
			channelId: formData.channel,
			regionId: formData.region,
			agencyIds: [formData.agency],
			manager: formData.manager,
			seller: formData.seller,
			ppz: formData.ppz,
		},
		policyNo: formData.policyNumber,
		reportedDateFrom: toIsoDateFormat(formData.reportDateFrom),
		reportedDateTo: toIsoDateFormat(formData.reportDateTo),
		scanned: isNilOrEmptyString(formData.scan) ? undefined : Boolean(formData.scan),
		userRole,
		withoutPpz: true,
		documentTypeId: formData.documentType,
	};

	return cleanse(requestBody);
};
